const FREE_FALLING_OBJECT_ACCELERATION = 0.00125;
const MIN_DRAG_FORCE_COEFFICIENT = 0.0005;
const MAX_DRAG_FORCE_COEFFICIENT = 0.0009;
const ROTATION_SLOWDOWN_ACCELERATION = 0.00001;

const INITIAL_SHAPE_RADIUS = 6;
const INITIAL_EMOJI_SIZE = 80;

const MIN_INITIAL_CONFETTI_SPEED = 0.9;
const MAX_INITIAL_CONFETTI_SPEED = 1.7;

const MIN_FINAL_X_CONFETTI_SPEED = 0.2;
const MAX_FINAL_X_CONFETTI_SPEED = 0.6;

const MIN_INITIAL_ROTATION_SPEED = 0.03;
const MAX_INITIAL_ROTATION_SPEED = 0.07;

const MIN_CONFETTI_ANGLE = 15;
const MAX_CONFETTI_ANGLE = 82;

const MAX_CONFETTI_POSITION_SHIFT = 150;

const SHAPE_VISIBILITY_TRESHOLD = 100;

const DEFAULT_CONFETTI_NUMBER = 250;
const DEFAULT_EMOJIS_NUMBER = 40;

const DEFAULT_CONFETTI_COLORS = [];

export {
  FREE_FALLING_OBJECT_ACCELERATION,
  MIN_DRAG_FORCE_COEFFICIENT,
  MAX_DRAG_FORCE_COEFFICIENT,
  ROTATION_SLOWDOWN_ACCELERATION,
  INITIAL_SHAPE_RADIUS,
  INITIAL_EMOJI_SIZE,
  MIN_INITIAL_CONFETTI_SPEED,
  MAX_INITIAL_CONFETTI_SPEED,
  MIN_FINAL_X_CONFETTI_SPEED,
  MAX_FINAL_X_CONFETTI_SPEED,
  MIN_INITIAL_ROTATION_SPEED,
  MAX_INITIAL_ROTATION_SPEED,
  MIN_CONFETTI_ANGLE,
  MAX_CONFETTI_ANGLE,
  MAX_CONFETTI_POSITION_SHIFT,
  SHAPE_VISIBILITY_TRESHOLD,
  DEFAULT_CONFETTI_NUMBER,
  DEFAULT_EMOJIS_NUMBER,
  DEFAULT_CONFETTI_COLORS,
};
